module.exports = {
      id: "more-outline-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#more-outline",
      toString: function () {
        return this.url;
      }
    }